export const long_term_cashing = 60 * 1000 * 20;
export const short_term_cashing = 60 * 1000 * 5;
